import { cqrs } from '@faro/http-clients';
import { toVeevaCaseReportFormMappingOrder, VeevaCaseReportFormMappingOrder } from '@faro/study-designer-model';
import { StudyPathParameter } from '../parameter';

export const veevaCaseReportFormMappingOrderClient = {
    list: cqrs<VeevaCaseReportFormMappingOrder>(
        '/api/study-designer/studies/:studyId/veeva-case-report-form-mapping-order',
        toVeevaCaseReportFormMappingOrder
    ).list<StudyPathParameter>(),
};
